import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import SiderBarMobileItem from "@/react-components/SiderBar/MobileItem";

class MobileSecondLevelMenu extends React.Component {
  click = (item) => {
    if (item.path) {
      const { click } = this.props;
      click && click(item);
    } else {
      item.open = !item.open;
      this.forceUpdate();
    }
  };

  render() {
    const { menu, t, click, dismiss } = this.props;
    return (
      <nav className="sp-menu-nav-container">
        <div
          className="menu-back-container sp-menu-back-container"
          onClick={dismiss}
        >
          <img alt="" src={require("@/assets/images/menu-back.svg")} />
          <div>{t("TWBC0001_back")}</div>
        </div>
        <div className="sp-menu-divider" />
        <div className="sp-nav">
          {menu.children &&
            menu.children.map((item, index) => (
              <React.Fragment key={index}>
                <SiderBarMobileItem
                  item={item}
                  click={() => this.click(item)}
                />
                {item.open && item.children && item.children.length > 0
                  ? item.children.map((item1, index1) => (
                      <SiderBarMobileItem
                        key={index1}
                        item={item1}
                        click={() => click && click(menu)}
                        secondLevel
                      />
                    ))
                  : null}
              </React.Fragment>
            ))}
        </div>
      </nav>
    );
  }
}

MobileSecondLevelMenu.propTypes = {
  menu: PropTypes.object.isRequired,
  click: PropTypes.func,
  dismiss: PropTypes.func,
};

MobileSecondLevelMenu.defaultProps = {
  click: undefined,
  dismiss: undefined,
};

export default withTranslation()(MobileSecondLevelMenu);
